<template>
  <div>
    <div style="max-width: 750px; margin-top: 50px;" class="mx-auto">
      <p_agent :pd="this.siteConf.Link" />
      <div class="loading" v-if="loadFlag">Loading&#8230;</div>
    </div>
  </div>
</template>

<script>
//import localStorageSvc from "@/services/localStorage";
import p_agent from "@/pages/app/agent/home/agentInfo";
import dataSvc from "@/services/dataService";
export default {
  components: { p_agent },
  data() {
    return {
      siteConf: {},
      loadFlag: false,
      siteID: this.$route.params.siteid
    };
  },
  methods: {
    loadPage() {
      this.loadFlag = true;
      dataSvc
        .getSiteConf(this.siteID)
        .then(res => {
          this.loadFlag = false;
          if (res.data.ReturnStatus.ReturnCode == 200) {
            if(res.data.User==null){
              this.$router.push('/' + this.siteID);
              return;
            }
            this.siteConf = res.data;
          } else {
            this.$router.push("/");
          }
        })
        .catch(() => {
          this.$router.push("/");
        });
    }
  },
  created() {
    this.loadPage();
  }
};
</script>

<style>
</style>